var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.unread != 0)?_c('span',[_vm._v(_vm._s(_vm._f("checkSize")(_vm.unread)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }